'use client';

import { useEffect } from 'react';
import { logger } from '@/lib/logger';
import { ErrorDisplay } from '@/components/error-display';

export default function WorkerError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logger.error('Worker route error:', error);
  }, [error]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <ErrorDisplay
        title="Something went wrong"
        message="We ran into a problem loading this page. Please try again."
        error={error}
        onRetry={reset}
        onGoHome={() => window.location.href = '/dashboard'}
      />
    </div>
  );
}
